(ns portal.service-keys.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/wpp/content-actions/trash.svg$default" :as Trash]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.service-key :as q]
            [common.util :refer [format-iso-string]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-revoke :service-key/confirm-revoke
  [{:keys [service-key-id]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {revoke :mutate} (use-mutation (q/revoke-service-key-mutation {:advertiser-id advertiser-id}))]
    (deletion-confirmation
     {:entity-name         "Service Key"
      :on-submit           #(revoke service-key-id)})))

(defui revoke-action [row]
  ($ GridActionsCellItem
     {:key "delete"
      :label "delete"
      :icon ($ SvgIcon {:inheritViewBox true :component Trash})
      :onClick #(rf/dispatch [:modal/open {:id :service-key/confirm-revoke
                                           :props {:service-key-id (:id row)}}])}))

(defn- format-date [iso-string]
  (if iso-string (format-iso-string iso-string) "—"))

(def columns
  #js [#js {:field       "name"
            :headerName  "Name"
            :type        "string"
            :minWidth    180
            :flex        2
            :valueGetter (fn [_v row] (:name row))}
       #js {:field       "role"
            :headerName  "Role"
            :type        "string"
            :minWidth    160
            :flex        1.5
            :sortable    false
            :valueGetter (fn [_v row] (:role-name row))}
       #js {:field          "created-at"
            :headerName     "Created"
            :type           "string"
            :minWidth       160
            :flex           1.5
            :sortable       true
            :valueGetter    (fn [_v row] (:created-at row))
            :valueFormatter (fn [v] (format-date v))}
       #js {:field          "last-used-at"
            :headerName     "Last used"
            :type           "string"
            :minWidth       160
            :flex           1.5
            :sortable       false
            :valueGetter    (fn [_v row] (:last-used-at row))
            :valueFormatter (fn [v] (format-date v))}
       #js {:field         "actions"
            :type          "actions"
            :getActions    (fn [^js params]
                             #js [($ revoke-action (.-row params))])}])

(def no-rows-overlay
  (uix/as-react
   (fn [{:keys [is-error]}]
     ($ Stack {:alignItems    "center"
               :justifyContent "center"
               :height        "100%"}
        ($ Typography
           (cond
             is-error "Could not load Service Keys"
             :else "No Service Keys have been created for this advertiser yet"))))))

(defn- get-row-id [row] (:id row))

(def toolbar
  (uix/as-react
   (fn []
     ($ dg/grid-toolbar {:sx #js {:justifyContent "space-between"}}
        ($ Button
           {:variant     "contained"
            :on-click    #(rf/dispatch [:ocp/open {:id :service-key/create}])
            :data-testid "AddServiceKeyButton"}
           "Add Service Key")))))

(def page-size 10)

(defui table []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isPending isError]} (use-query (q/service-keys-query {:advertiser-id advertiser-id}))]
    ($ DataGridPremium
       {:columns      columns
        :loading      isPending
        :rows         (to-array (or (:service-keys data) []))
        :getRowId     get-row-id
        :pagination   true
        :disableRowSelectionOnClick true
        :pageSizeOptions #js [page-size]
        :initialState  #js {:pagination #js {:paginationModel #js {:pageSize page-size}}}
        :slots        #js {:toolbar        toolbar
                           :noRowsOverlay  no-rows-overlay}
        :slotProps    #js {:baseTextField dg/grid-toolbar-outlined-input
                           :noRowsOverlay #js {:is-error isError}}
        :sx           (clj->js dg/actions-column-sx)})))
